import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

// No native white/light export of the wordmark exists — reuse the color PNG
// and flatten it to white via the .desktop-dark CSS filter (theme.scss),
// since the auth pages sit on the primary-color background.
import desktopDark from '@/assets/brand-logos/edunet-logo-color.png'

interface AuthLayoutProps {
  title: string
  subtitle?: string
  children: ReactNode
  footer?: ReactNode
  wide?: boolean
}

/**
 * Shared shell for every public auth screen (login, register, verify-email,
 * forgot/reset password, 2FA) — mirrors the Zynix theme's
 * sign-in-basic.html card layout, hand-ported the same way AppShellLayout
 * ported the dashboard shell in Phase 4.
 */
export function AuthLayout({ title, subtitle, children, footer, wide = false }: AuthLayoutProps) {
  return (
    <div className="authentication-background authenticationcover-background position-relative">
      <div className="container">
        <div className="row justify-content-center authentication authentication-basic align-items-center h-100">
          <div className={wide ? 'col-xxl-6 col-xl-7 col-lg-9 col-md-11 col-12' : 'col-xxl-4 col-xl-5 col-lg-5 col-md-6 col-sm-8 col-12'}>
            <div className="mb-3 d-flex justify-content-center auth-logo">
              <Link to="/">
                <img
                  src={desktopDark}
                  alt="Job Portal"
                  className="desktop-dark"
                  style={{ height: 40 }}
                />
              </Link>
            </div>
            <div className="card custom-card my-4 border z-3 position-relative">
              <div className="card-body p-0">
                <div className="p-5">
                  <p className="h4 fw-semibold mb-0 text-center">{title}</p>
                  {subtitle && <p className="mb-3 text-muted fw-normal text-center">{subtitle}</p>}
                  {children}
                </div>
              </div>
            </div>
            {footer && <div className="text-center mb-4">{footer}</div>}
          </div>
        </div>
      </div>
    </div>
  )
}
